import { atom, useAtomValue, useSetAtom } from 'jotai'

const currentPageAtom = atom(1)
const itemsPerPageAtom = atom(1)
const totalItemsAtom = atom(0)

// setter com clamp seguro
export const setCurrentPageClampedAtom = atom(null, (get, set, nextPage: number) => {
  const total = get(totalItemsAtom)
  const perPage = get(itemsPerPageAtom)
  const totalPagesRaw = Math.ceil(total / perPage)
  const totalPages = Math.max(1, totalPagesRaw) // evita 0
  const clamped = Math.max(1, Math.min(totalPages, nextPage || 1))
  set(currentPageAtom, clamped)
})

const paginationAtom = atom(get => {
  const pageRaw = get(currentPageAtom)
  const perPage = get(itemsPerPageAtom)
  const total = get(totalItemsAtom)

  const totalPagesRaw = Math.ceil(total / perPage)
  const totalPages = Math.max(1, totalPagesRaw) // evita 0
  const currentPage = Math.max(1, Math.min(totalPages, pageRaw))

  const startIndex = total === 0 ? 0 : (currentPage - 1) * perPage
  const endIndex = total === 0 ? 0 : Math.min(currentPage * perPage, total)

  return {
    currentPage,
    itemsPerPage: perPage,
    totalItems: total,
    totalPages,
    startIndex,
    endIndex
  }
})

export const usePagination = () => useAtomValue(paginationAtom)
export const useSetCurrentPage = () => useSetAtom(setCurrentPageClampedAtom)

// (opcional) setters básicos
export const useSetTotalItems = () => useSetAtom(totalItemsAtom)
export const useSetItemsPerPage = () => useSetAtom(itemsPerPageAtom)
